import { JWT_KEY, JWT_REFRESH_KEY } from "~/shared/apis/constant"

interface saveJwtTokenProps {
  accessToken: string
  refreshToken: string
}
export const getJWTToken = () => {
  return {
    accessToken: window.sessionStorage.getItem(JWT_KEY),
    refreshToken: window.sessionStorage.getItem(JWT_REFRESH_KEY),
  }
}

export const saveJWTToken = ({ accessToken, refreshToken }: saveJwtTokenProps) => {
  window.sessionStorage.setItem(JWT_KEY, accessToken)
  window.sessionStorage.setItem(JWT_REFRESH_KEY, refreshToken)
}

export const clearJWTToken = () => {
  window.sessionStorage.removeItem(JWT_KEY)
  window.sessionStorage.removeItem(JWT_REFRESH_KEY)
}
